'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = undefined;

require('slick-carousel');

var _Overlay = require('components/Overlay2');

var _Overlay2 = _interopRequireDefault(_Overlay);

var _Dom = require('common/Dom');

var _Dom2 = _interopRequireDefault(_Dom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Setup variables
var windowWidth = window.innerWidth;
var numMenuFrames = 3;
var $mobileMenu = $('.mobile-menu');
var $mobileMenuContainer = $('.js-mobile-nav');
var $backLink = $('.mobile-menu .go-back');
var $menuLink = $('.mobile-menu .menu-item-link');
var $hideTopBar = $('[data-hide-top-bar]');
var $mobileCategory = $('[data-trigger-menu]');
var $mobileMenus = $('[data-mobile-menu]');
var $mobileMenuDropdownBtn = $('[data-mobile-menu-btn]');

// Update "windowWidth" to current window width
var updateScreenDimensions = function updateScreenDimensions() {
  windowWidth = window.innerWidth;
};

// Slide mobile menu along X-axis to selected frame
var slideToFrame = function slideToFrame(frameIndex) {
  var newFrameClass = 'level-' + frameIndex;

  for (var i = 0; i <= numMenuFrames; i++) {
    var oldFrameClasses = 'level-' + i;

    $mobileMenu.removeClass(oldFrameClasses);
  }

  $mobileMenu.addClass(newFrameClass);
};

// Move mobile menu to next position based on which menu item is clicked
var updateMobileMenu = function updateMobileMenu(self) {
  var nextMenuFrame = $(self).data('slide-to');
  var nextMenuToDisplay = $(self).data('next-menu');

  $('.submenu, .megamenu').hide();
  $('[data-menu="' + nextMenuToDisplay + '"]').show();
  slideToFrame(nextMenuFrame);
  $mobileMenu.scrollTop(0);
};

var openMobileMenu = function openMobileMenu() {
  // DYEventTracking.mobileMenuOpened();
  _Overlay2.default.enable();
  // $('html,body').addClass('no-scroll');
  $mobileMenuContainer.addClass('active');
  $('.inline-cart').removeClass('is-active');
  $('[data-inline-cart-header-trigger]').attr('aria-expanded', 'false');
  $('[data-inline-cart-close-button]').attr('aria-expanded', 'false');
  $('.inline-cart-trigger').removeClass('transparent');
  // 05/10/2018 - DY Mobile Test 2
  // Trigger resize for explore by series sliders
  setTimeout(function () {
    $('.js-explore-by-series-slider').slick('setPosition');
  }, 100);
};

var closeMobileMenu = function closeMobileMenu() {
  _Overlay2.default.disable();
  $mobileMenuContainer.removeClass('active');
  // $('html, body').removeClass('no-scroll');
  // Reset mobile menu to frame 0
  setTimeout(function () {
    slideToFrame(0);
  }, 310);
};

var toggleMobileMenus = function toggleMobileMenus(_ref) {
  var self = _ref.currentTarget;

  var $self = $(self);
  var menu = $self.attr('data-trigger-menu');
  var isSelf = $self.hasClass('is-active');
  var $otherCategory = $mobileCategory.not($self);
  var otherText = $otherCategory.attr('data-trigger-menu');
  var selfText = $self.attr('data-trigger-menu');

  if (isSelf) {
    closeMobileMenu();
    $mobileCategory.removeClass('is-active');
    $self.find('p').text(selfText);
    $mobileMenus.hide();
    _Overlay2.default.disable();
  } else {
    $otherCategory.find('p').text(otherText);
    $mobileCategory.removeClass('is-active');
    $self.addClass('is-active').find('p').text('+');
    $mobileMenus.hide();
    $('[data-mobile-menu="' + menu + '"]').show();
    openMobileMenu();
    _Overlay2.default.enable();
    // 05/10/2018 - DY Mobile Test 2
    // Trigger resize for explore by series sliders
    setTimeout(function () {
      $('.js-explore-by-series-slider').slick('setPosition');
    }, 100);
  }
};

var mobileDropdownMenuHandler = function mobileDropdownMenuHandler(event) {
  event.stopPropagation();
  var $self = $(event.currentTarget);

  $self.toggleClass('active');
};

var bindUIActions = function bindUIActions() {
  $hideTopBar.on('click', function () {
    $('.header-nav-top-bar').hide();
    $('[data-hide-mobile-bar]').addClass('mobile-bar-hide');
    $('main').removeClass('global-banner-enabled');
  });

  // Trigger mobile menu change
  $menuLink.add($backLink).click(function (_ref2) {
    var self = _ref2.currentTarget;

    if (!$(self).hasClass('last-link')) {
      // Follow Link
    } else {
      event.stopPropagation();
      event.preventDefault();
      updateMobileMenu(self);
    }
  });

  // Hide mobile menu in desktop view (> 769px)
  $(window).resize(function () {
    updateScreenDimensions();
    if (windowWidth >= 993) {
      if ($mobileMenuContainer.hasClass('active')) {
        $mobileMenuContainer.removeClass('active');
        $('.trigger-mobile-menu').removeClass('active');
        // $('html, body').removeClass('no-scroll');
      }
    }
  });

  $('.js-toggle-mobile-subnav').on('click', function (_ref3) {
    var self = _ref3.currentTarget;

    var $thisSubnav = $(self).siblings('.mobile-sub-nav');
    var $thisToggle = $(self).find('.mobile-subnav-toggle');

    $thisSubnav.slideToggle(250);
    $thisToggle.toggleClass('active');
    // 05/10/2018 - DY Mobile Test 2
    // Trigger resize for explore by series sliders
    setTimeout(function () {
      $('.js-explore-by-series-slider').slick('setPosition');
    }, 100);
  });

  $mobileCategory.on('click', toggleMobileMenus);

  $('[data-overlay]').on('click', function () {
    closeMobileMenu();
    $mobileCategory.removeClass('is-active');
    $mobileMenus.hide();

    $('.header-mobile-category').each(function (index) {
      var resetText = $(this).attr('data-trigger-menu');

      $(this).find('p').text(resetText);
    });
  });

  $mobileMenuDropdownBtn.on('click', mobileDropdownMenuHandler);
};

var init = exports.init = function init() {
  bindUIActions();
  _Overlay2.default.init();
};

exports.default = {
  init: init
};